import React from 'react'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import { useUserContext } from 'app/shared/state/user-context'
import getDisplayName from 'app/shared/utils/getDisplayName'
import { IconButton, Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useStyles } from './header-info.styles'
import { useAppContext } from 'app/app-context/app-context'

const HeaderInfo = () => {
  const classes = useStyles()
  const { currentUser } = useUserContext()
  const { isCompanyAdmin } = useAppContext()
  const history = useHistory()

  if (!currentUser) {
    return <></>
  }

  const logOut = () => {
    localStorage.removeItem('token')
    window.location.href = '/login'
  }

  const goToProfile = () => {
    history.push(isCompanyAdmin === false ? '/' : `/users/${currentUser.id}`)
  }

  return (
    <div className={classes.root}>
      <div>
        <a
          onClick={(e) => {
            e.preventDefault()
            goToProfile()
          }}
          href={isCompanyAdmin === false ? '/' : `/users/${currentUser.id}`}
        >
          {getDisplayName(currentUser)}
        </a>
        <Tooltip title="Naar profiel">
          <IconButton size="small" onClick={goToProfile} color="primary">
            <AccountBoxIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.actionContainer}>
        <Tooltip title="Uitloggen">
          <IconButton size="small" onClick={logOut}>
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  )
}

export default HeaderInfo
